import { Sparkles, Volume2, X } from "lucide-react";

export function VoicePanelHeader({ onClose }) {
  return (
    <header className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
      <div className="flex items-center gap-2">
        <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
          <Sparkles className="h-3.5 w-3.5" />
        </span>
        <div className="leading-tight">
          <p className="text-sm font-medium text-slate-900">Voice interview</p>
          <p className="text-[10px] uppercase tracking-[0.14em] text-slate-400">
            powered by Whisper
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="text-slate-400 hover:text-slate-700"
        aria-label="Close voice interview"
        data-testid="voice-close-button"
      >
        <X className="h-4 w-4" />
      </button>
    </header>
  );
}

export function FollowUpBubble({ text, onReplay }) {
  return (
    <div
      className="rounded-xl bg-emerald-50 border border-emerald-100 p-3 text-emerald-900"
      data-testid="voice-follow-up"
    >
      <p className="text-[10px] uppercase tracking-[0.14em] text-emerald-700">
        Interviewer
      </p>
      <p className="mt-1 leading-relaxed">{text}</p>
      <button
        type="button"
        onClick={onReplay}
        className="mt-2 inline-flex items-center gap-1 text-[11px] text-emerald-700 hover:text-emerald-900"
        data-testid="voice-replay-button"
      >
        <Volume2 className="h-3 w-3" /> hear it again
      </button>
    </div>
  );
}

export function TranscriptBubble({ text }) {
  if (!text) return null;
  return (
    <div
      className="rounded-xl bg-slate-50 border border-slate-100 p-3"
      data-testid="voice-transcript"
    >
      <p className="text-[10px] uppercase tracking-[0.14em] text-slate-500">
        You said
      </p>
      <p className="mt-1 leading-relaxed text-slate-800 whitespace-pre-wrap">
        {text}
      </p>
    </div>
  );
}

export function ApplyFieldsButton({ fields, onApply }) {
  if (!fields || Object.keys(fields).length === 0) return null;
  const n = Object.keys(fields).length;
  return (
    <button
      type="button"
      onClick={onApply}
      className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-slate-900 text-white px-3 py-2 text-sm font-medium hover:bg-slate-800"
      data-testid="voice-apply-button"
    >
      Apply {n} section{n === 1 ? "" : "s"} to my form
    </button>
  );
}
